import React from "react";

const LoadingImages = () => {
  return <p className="loading-images">Searching for Pokémon...</p>;
};

export default LoadingImages;
